exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-check[data-v-0b852f69]{margin-bottom:.25rem}.form-check-label[data-v-0b852f69]{font-size:.75rem;margin-left:.25rem}.cursor-pointer[data-v-0b852f69]{cursor:pointer}.cursor-pointer[data-v-0b852f69]:hover{opacity:.7}.badge-sm[data-v-0b852f69]{font-size:.7rem;padding:.2rem .4rem}", ""]);

// exports
